import Modal from "../../../../ui/Modal/Modal";
import ConfirmationModal from "../../../../ui/Modal/ConfirmationModal";
import { useState } from "react";

function ConfirmChangesModal({
  isOpen,
  onClose,
  onSubmit,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
}) {
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm changes"
      subtitle={
        <>
          <b>Note:</b> These changes will not update your keyword
          recommendations. To get new recommendations from your changes select
          refresh on the keyword recommendations page.
        </>
      }
    >
      <ConfirmationModal
        onSubmit={async () => {
          setLoading(true);
          await onSubmit();
          setLoading(false);
        }}
        onClose={onClose}
        loading={loading}
        confirmationText="Confirm and save"
      />
    </Modal>
  );
}

export default ConfirmChangesModal;
